const configLanguageData = require('./ConfigLanguageData');
// import LanguageManager from '../../../../manager/language_manager';
// const uiLabel = require('../uiextend/ULabel.js');
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function () {

        var context = this, args = arguments;
        //cc.log("this:" + this + ",args:" + arguments + "," + "context:" + context);
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

cc.Class({
    extends: cc.Component,

    editor: {
        executeInEditMode: true,
        menu: 'UI/TLabel'
    },
    properties: {
        TLabelKey: {
            get() {
                return this._tlabelKey;
            },
            set(val) {
                if (this._tlabelKey !== val) {
                    this._tlabelKey = val;
                        if (CC_EDITOR) {
                            if (!this._debouncedUpdateLabel) {
                                this._debouncedUpdateLabel = debounce(this.updateULabel, 200);
                            }
                            this._debouncedUpdateLabel();
                        }
                }
            }
        },
        _tlabelKey: ''
    },

    onLoad() {
        // if (CC_EDITOR) {
        //     if (this._tlabelKey != "")
        //     {
        //         this._debouncedUpdateLabel = debounce(this.updateULabel, 200);
        //     }
        //     if (!configLanguageData.inst) {
        //             configLanguageData.init();
        //         }
        //     this.fetchRender();
        // }
    },
    fetchRender() {
        let label = this.getComponent(cc.Label);
        if (label) {
            this.label = label;
            this.updateULabel();
            return;
        }
    },

    updateULabel() {
        // if (!this.label) {
        //     this.label = this.getComponent(cc.Label);
        // }
        // if (!this.label) {
        //     cc.error('Failed to update localized label, label component is invalid!');
        //     return;
        // }
        
        // let self = this
        // // LanguageManager.loadFont(window.i18n.curLang,function(){
        // //     self.label.font = LanguageManager._curFont
        // // })

        // //在这里修改读取json文件的类容
        // if(configLanguageData.containsKey(this._tlabelKey))
        // {
        //     let localizedString = configLanguageData.parse(this._tlabelKey);
        //     if (localizedString) {
        //         this.label.string = localizedString
        //     }
        // }
    }
});